<template>
  <div v-if="product && productPrice" class="f-col items-start gap-4">
    <vf-carousel class-container="space-x-2 c-brand-4 -mx-4 scroll-px-4 px-4" class-controls="!hidden" :props-container="{ tabindex: 0 }">
      <product-eyebrow v-if="product.eyebrow?.label" class="b b-grey-80 rounded-full bg-grey-90 px-2 py-1" />
      <product-badge v-if="product.badge" v-bind="product.badge" class="b b-grey-80 rounded-full bg-grey-90 px-2 py-1" />
      <div id="social-proof-container" />
    </vf-carousel>
    <product-pricing
      class="body-4"
      class-current="subtitle-5"
      :currency="product.currency"
      :is-digital-product
      :price="productPrice"
      :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
      :show-omnibus-badge="$feature.showOmnibusBadgeOnQuickshopAndPDP"
      show-sale-price-tooltip
    />
    <p v-if="product.promoExclusionsMessage" class="body-5 c-grey-20">
      {{ product.promoExclusionsMessage }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const { isDigitalProduct, product, productPrice } = usePdp()
</script>
